import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./Experience.css";

// Newest first.
const roles = [
  {
    title: "Student Assistant / Grader",
    employer: "University of Louisville, J.B. Speed School of Engineering",
    location: "Louisville, KY",
    // TODO(verify): end date. The site previously listed January 2026.
    dates: "August 2025 – January 2026",
    bullets: [
      "Graded six progressively complex Traveling Salesperson Problem programming projects for approximately 172 undergraduate and graduate students in CSE 545 Artificial Intelligence.",
      "Reviewed source code and technical reports against detailed assignment requirements and grading criteria, using a consistent, requirement-by-requirement process.",
      "Identified errors and recurring issues, such as incorrect algorithm selection and flawed tour-order logic, and explained findings in written feedback on correctness, edge cases, performance, documentation, and computational complexity.",
      "Clarified ambiguous grading situations with the instructional team to keep evaluation fair and repeatable while meeting weekly grading deadlines.",
    ],
  },
  {
    title: "QA Software Engineer",
    employer: "Akkodis — Assignment at GE Appliances",
    location: "Louisville, KY",
    dates: "March 2025 – June 2025",
    bullets: [
      "Performed manual functional, regression, and integration testing for GE UltraFresh front-load washer software and connected hardware.",
      "Created and executed test cases to verify requirements and investigate issues involving control boards, user interfaces, sensors, and connected features.",
      "Reproduced software issues and documented defects, test results, and supporting evidence in Jira.",
      "Used LabVIEW, TestStand, and Git during testing and troubleshooting.",
    ],
  },
  {
    title: "Python Software Engineer I",
    employer: "University of Louisville Logistics and Distribution Institute",
    location: "Louisville, KY",
    dates: "March 2024 – July 2024",
    bullets: [
      "Designed and developed a web-based decision support tool for predicting pavement conditions, tailored to the needs of Kentucky State DOT engineers.",
      "Built the front end with React and the back end with Python and Flask.",
      "Created an interface for engineers to input data in CSV format and integrated the application with an existing machine learning prediction model.",
      "Added visual representations of prediction results, such as Google Charts, to make the data easier to interpret.",
    ],
  },
  {
    title: "Data Integrity Analyst Co-op I",
    employer: "The Rawlings Group",
    location: "La Grange, KY",
    dates: "August 2022 – December 2022",
    bullets: [
      "Monitored client data files and validated them against data entered in SQL Server databases to confirm data quality and integrity.",
      "Tracked failures found during client file monitoring, and created, validated, and sent weekly Excel reports on them.",
      "Maintained data integrity using automated processes to capture data, update records, and delete outdated data.",
      "Used SQL Server and SSIS for ETL (extract, transform, load) processes.",
    ],
  },
  {
    title: "Software Engineer Co-op II",
    employer: "The Rawlings Group",
    location: "La Grange, KY",
    dates: "August 2021 – December 2021",
    bullets: [
      "Served in a QA role, testing new features and changes in different environments and executing manual test cases.",
      "Collaborated with six interns and senior developers to design, develop, test, deploy, and document new software applications.",
      // TODO(verify): Angular (2+) or AngularJS for these applications.
      "Improved the front end of existing Angular applications by adding new features.",
      "Added logging to applications, which helped other developers with debugging.",
    ],
  },
  {
    title: "Software Engineer Co-op I",
    employer: "The Rawlings Group",
    location: "La Grange, KY",
    dates: "January 2021 – May 2021",
    bullets: [
      // TODO(verify): this role references both AngularJS and Angular 12.
      "Improved the front end of four AngularJS applications and implemented new features based on business requirements.",
      "Developed a full-stack web application using ASP.NET (C#), Angular 12, and Dapper that allows users to search for ICD-10 codes.",
      "Identified, documented, and tracked bugs.",
      "Worked with development teams and product managers on software solutions, and took part in agile development, including design, implementation, and deployment.",
    ],
  },
];

class Experience extends Component {
  render() {
    return (
      <div className="Page">
        <div className="PageContainer">
          <h1 className="PageHeading">Experience</h1>
          <p className="PageIntro">
            Professional roles in software development, quality assurance,
            and data integrity, newest first.
          </p>
          <ol className="RoleList">
            {roles.map((role) => (
              <li className="Card RoleCard" key={role.title + role.dates}>
                <h2 className="RoleTitle">{role.title}</h2>
                <p className="RoleEmployer">{role.employer}</p>
                <p className="RoleMeta">
                  <span>{role.location}</span>
                  <span aria-hidden="true"> · </span>
                  <span>{role.dates}</span>
                </p>
                <ul className="RoleBullets">
                  {role.bullets.map((bullet) => (
                    <li key={bullet}>{bullet}</li>
                  ))}
                </ul>
              </li>
            ))}
          </ol>
        </div>
      </div>
    );
  }
}

export default Experience;
